export default (channels = ['email', 'sms', 'phone']) => data => `
  permissions: {
    marketing: {
      ${channels
        .map(
          channel => `\t\t${channel}: ${!!data.permissions.marketing[channel]}`
        )
        .join(',\n')}
    }
  }
`
